////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskRacksRequest = {
	[ActionsTypes.RESET_DATA_KIOSK_RACKS_REQUEST]: (state) => {
		return update(state, {
			kioskRacksRequest: {
				item: {
					$set: {},
				},
				options: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_RACKS_REQUEST]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				item: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_RACKS_REQUEST_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_RACKS_REQUEST_FAILURE]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				options: {
					$set: {},
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				options: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM_FAILURE]: (state, payload) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK_FAILURE]: (state, payload) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_FAILURE]: (state, payload) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_FAILURE]: (state, payload) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_FAILURE]: (state, payload) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK]: (state) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: true,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_FAILURE]: (state, payload) =>
		update(state, {
			kioskRacksRequest: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
}

export default kioskRacksRequest
